import { render, staticRenderFns } from "./TipDressing.vue?vue&type=template&id=571ed376&scoped=true"
import script from "./TipDressing.vue?vue&type=script&lang=js"
export * from "./TipDressing.vue?vue&type=script&lang=js"
import style0 from "./TipDressing.vue?vue&type=style&index=0&id=571ed376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571ed376",
  null
  
)

export default component.exports